import React from "react";
import SignInFormAmbassador from "../components/SignInFormAmbassador";

export default function SignIn() {
  return <SignInFormAmbassador />;
}
